import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { MagnifyingGlass } from '@liveauctioneers/hammer-ui-core/icons';
import Input from '@liveauctioneers/caterwaul-components/lib/Input/Input';
import styled from 'styled-components';

interface Props {
    disabled?: boolean;
    placeholderMessage?: string;
    shortOnMobile?: boolean;
    submitFilterTerm: (filterTerm: string) => void;
}

const FilterTerm = ({ disabled, placeholderMessage = '', shortOnMobile, submitFilterTerm }: Props) => {
    const [filterTerm, setFilterTerm] = useState('');

    const handleFilterTermChange = (event: ChangeEvent<HTMLInputElement>) => {
        setFilterTerm(event.target.value);
    };
    const handleSubmitFilterTerm = () => {
        if (filterTerm) {
            submitFilterTerm(filterTerm);
            setFilterTerm('');
        }
    };
    const handleEnterTabDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (['Enter', 'Tab'].includes(event.key)) {
            handleSubmitFilterTerm();
        }
    };

    return (
        <StyledFilterTerm $shortOnMobile={shortOnMobile}>
            <StyledInput
                aria-label={placeholderMessage}
                disabled={disabled}
                hideSpacer
                iconRight={
                    <StyledSearchIconSmall
                        data-testid="filter-icon"
                        onClick={handleSubmitFilterTerm}
                        size="sm"
                    />
                }
                onChange={handleFilterTermChange}
                //@ts-ignore
                onKeyDown={handleEnterTabDown}
                placeholder={placeholderMessage}
                small
                value={filterTerm}
            />
        </StyledFilterTerm>
    );
};

export default FilterTerm;

const StyledFilterTerm = styled.div<{ $shortOnMobile?: boolean }>`
    margin-right: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    position: relative;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        margin-top: ${({ $shortOnMobile }) => ($shortOnMobile ? 0 : '25px')};
        margin-right: 0;
    }
`;

const StyledInput = styled(Input)`
    border: 0 none transparent !important;
    width: 185px;
    transition: width 0.5s;
    font-family: ${({ theme }) => theme.typography.fontPrimary};

    &&&& input {
        padding: 0 10px;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        width: 100%;
    }
`;

const StyledSearchIconSmall = styled(MagnifyingGlass)`
    cursor: pointer;
`;
